export interface PracticeProblemsFilters {
  difficulty?: string;
  search?: string;
  tag?: string;
}

// Identity-scoped React Query key for the practice-problems list.
// GET /api/problems returns role-dependent rows (admins also see unpublished
// problems), so the cache MUST be keyed by the caller's user id. Without it, an
// admin's cached response — containing unpublished problems — is served straight
// from the shared, never-cleared QueryClient to a different non-admin user who
// logs into the same SPA session without a page reload.
export function practiceProblemsQueryKey(
  userId: string | null | undefined,
  filters: PracticeProblemsFilters = {},
): Array<string | null | undefined> {
  return [
    'practice-problems',
    userId ?? 'anon',
    filters.difficulty,
    filters.search,
    filters.tag,
  ];
}
